import PropTypes from 'prop-types';

var customOptions;
(function (customOptions) {
    customOptions["PERCENT"] = "customPercent";
    customOptions["FLAT"] = "customFlat";
})(customOptions || (customOptions = {}));
var propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedOption: PropTypes.object,
    allowCustom: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};
var defaultProps = {
    allowCustom: true,
    narrow: false,
    disabled: false,
};

export { customOptions, defaultProps, propTypes };
